import { useState, useEffect } from 'react';
import './index.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import AnalysisModal from './components/AnalysisModal';
import CookieBanner from './components/CookieBanner';
import StickyBar from './components/StickyBar';

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal  = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    const checkVisibility = () => {
      document.querySelectorAll<Element>('.fade-up:not(.visible)').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.88) {
          el.classList.add('visible');
        }
      });
    };
    checkVisibility();
    window.addEventListener('scroll', checkVisibility, { passive: true });
    return () => window.removeEventListener('scroll', checkVisibility);
  }, []);

  return (
    <>
      <div className="aurora-wrap" aria-hidden="true">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
        <div className="orb orb-3" />
      </div>

      <Nav onAnalysisClick={openModal} />

      <main>
        <Hero onAnalysisClick={openModal} />
        <Stats />
        <Services />
        <HowItWorks />
        <Portfolio />
        <Testimonials />
        <Pricing />
        <CtaSection onAnalysisClick={openModal} />
      </main>

      <Footer />
      <StickyBar onAnalysisClick={openModal} />
      <CookieBanner />
      <AnalysisModal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
}
